<div class="row principalDarkerBackground centrado fullHeight">
    <div class="card width90 ">
        <div class="card-container">
            <div class="padding30"></div>
            <div class="row centrado">
                <div class="col-md-12">
                    <img src="assets/images/logo.png" class="imgLogoMed">
                </div>
            </div>
            <div class="row ">
                <div class="padding50"></div>
                <div class="col-md-12 ">
                    <a *ngFor="let step of stepers"  (click)="gotoURL(step)" [ngClass]="{'principalBackground':
                    step.active, 'disabledBackground': !step.active }"
                       class="button  colorBlanco slide-in-top" [routerLinkActive]="step.active ? 'is-active' : 'is-disabled'">
                        <span class="centrado"  [ngClass]="{'secondaryBackground': step.active}"><i
                                class="{{step.icon}} fa-2x centrado"></i></span> <strong
                            class="alignLeft">{{step.name}}</strong></a>
                    <div class="padding10"></div>
                </div>
                <div class="padding50"></div>
                <div class="padding50"></div>
            </div>
        </div>
    </div>
</div>

